export default {
  auto: '*',
  store: {
    getters: {
      jobTypesOptions: (_, { jobtypes }) => [
        [null, ''],
        ...Object.values(jobtypes)
          .map(({ id, name }) => [id, name]),
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/jobtypes.js